import axios from "axios"
import axiosInstance from "./axiosInstance";

export const makeGet = async (endpoint)=>{
    const resp = await axios.get(endpoint,{
        headers:{
            "Content-Type":"application/json",
        }
    });

    return resp.data;
}

export const makePost = async (endpoint ,body)=>{
    const resp = await axios.post(endpoint,body,{
        headers:{
            "Content-Type":"application/json",
        }
    })
    return resp.data;
}

export const makeAuthenticatedGet = async (endpoint)=>{
    const token = localStorage.getItem('token');
    const response = await axiosInstance.get(endpoint, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
}

export const makeAuthenticatedPost = async (endpoint  , body )=>{
    const token = localStorage.getItem('token');
    const response = await axiosInstance.post(endpoint, body, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
}

export const makeAuthenticatedPatch = async (endpoint  , body )=>{
  const token = localStorage.getItem('token');
  const response = await axiosInstance.patch(endpoint, body, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
}

export const makePrivilagedPost = async (endpoint  , body ,secret) => {
    const token = secret;
    const response = await axiosInstance.post(endpoint, body, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
}

export const makePrivilagedPostForFile = async(endpoint , body ,secret) => {
    const token = secret;
    const response = await axiosInstance.post(endpoint, body, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
}

export const makeAuthenticatedPostForFile = async(endpoint , body )=>{
    const token = localStorage.getItem('token');
    const response = await axiosInstance.post(endpoint, body, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
}

export const makeAuthenticatedPatchForFile = async(endpoint , body )=>{
  const token = localStorage.getItem('token');
  const response = await axiosInstance.patch(endpoint, body, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
}

export const makePostForFile = async (endpoint , body)=>{
    const response = await axiosInstance.post(endpoint,body,{
        headers:{
           'Content-Type': 'multipart/form-data'
        }
    });

    return response.data;
}